import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  customerTagFromModel,
  validateCustomerTagCondition,
  type CustomerTagState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_TAG = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerTagState>>,
): ConditionType<CustomerTagState, ModelCondition.CustomerTag> => ({
  name: CONDITION_NAMES[ModelCondition.CUSTOMER_TAG],
  description(state) {
    return t("Customer tags: {{tags}}", { tags: state.tags.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<CustomerTagState>) {
    return React.createElement(Details, props);
  },
  empty: { tags: [] },
  fromModel(model) {
    return customerTagFromModel(model);
  },
  toModel(state) {
    return {
      type: ModelCondition.CUSTOMER_TAG,
      tags: state.tags,
      evaluationTime: state.evaluationTime,
    };
  },
  valid(state) {
    return validateCustomerTagCondition(state).valid;
  },
});
